import { useEffect, useState } from "react";
import { useAdminSettingContext } from "../../../context/AdminSettingContext";
import { AppList } from "./AppList";
import "./style.scss";
import { VersionList } from "./VersionList";

const VersionManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { selectedApp } = useAdminSettingContext();
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="dashboard flex flex-col p-[10px] gap-[10px]">
      <div className="font-semibold text-[20px]">Version</div>
      <AppList isMobile={isMobile} />

      {selectedApp ? <VersionList isMobile={isMobile} /> : <div></div>}
    </div>
  );
};
export { VersionManagement };
